import { Box, SxProps } from "@mui/material";
import { Theme as MuiTheme, styled } from '@mui/material/styles';
import { Link } from "react-router-dom";

export const mainBoxStyles: SxProps<MuiTheme> = {
  flexGrow: 1,
  p: 3,
  mt: -5,
  width: { sm: `calc(100% - 260px)` }, 
};

export const contentBoxStyles: SxProps<MuiTheme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#fff',
  mx: 'auto',
  width: '100%',
  maxWidth: '100%',
  boxShadow: 1,
  borderRadius: 1,
  p: 3,
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    display: 'block',
    margin: '0 auto',
  },
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
  },
  '& td, & th': {
    border: '1px solid #ddd',
    padding: '8px',
  },
  '& th': {
    backgroundColor: '#f2f2f2',
  },
};

export const customiseMaterialUITextBoxStyle = {
  margin: 0,
  fontSize: "14px",
  "& .MuiOutlinedInput-root": {
    color: "#000",
    fontWeight: "normal",
    // Class for the border around the input field
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(17, 25, 42, 0.7)",
      borderWidth: "1px",
      borderRadius: 0
    }
  },
  "& .MuiInputLabel-outlined": {
      color: "#2e2e2e",
      fontWeight: "500",
      transform: "translate(12.8px, 4px) scale(1)"
  },
  "& .MuiInputLabel-shrink": {
    transform: "translate(14px, -9px) scale(0.75)"
  },
  "& .MuiOutlinedInput-input": {
    padding: "4px 12.8px",
    color: "black",
    background: "White"
  },
  "& .MuiInputBase-inputMultiline": {
    padding: "0px",
    color: "black"
  }
}

export const customStyleButtonSelection = {
  fontSize: "10px",
  width: "100px",
  height: "20px",
  borderRadius: "1000px",
  color: "#11192A",
  borderTopRightRadius: "1000px",
  borderBottomRightRadius: "1000px",
  "&.MuiToggleButtonGroup-firstButton": {
      borderRadius: "1000px",
      borderTopRightRadius: "1000px",
      borderBottomRightRadius: "1000px",
  },
  "&.MuiToggleButtonGroup-lastButton": {
      borderRadius: "1000px",
      borderTopRightRadius: "1000px",
      borderBottomRightRadius: "1000px",
  },
  "&.Mui-selected": {
      background: "#11192A"
  },
  "&.Mui-selected:hover": {
      background: "#11192A"
  },
  "&:hover": {
    background: "#ffffff",
    color: "#11192A"
  }
}

export const primaryButtonStyles = {
    background: "#1B59DD",
    borderRadius: "4px",
    color: "#ffffff",
    fontWeight: "bold",
    padding: "8px 20px",
    height: "35px",
    width: "96px",
    "&:hover": {
        background: "#1B59DD",
    }
}

export const secondaryButtonStyles = {
  background: "#ffffff",
  borderRadius: "4px",
  padding: "8px 20px",
  color: "#11192A",
  fontWeight: "bold",
  height: "35px",
  width: "96px",
  "&:hover": {
      background: "#ffffff",
    }
}

export const formGroupStyle = {
 gap: "8px",
 alignItems: "center"
}

export const formLabelStyle = {
  fontWeight: "600",
  fontSize: "12px",
  color: "#11192A",
  lineHeight: "16px",
  margin: 0
}

export const ReactToastifyWrapper = styled("div")({
  display: "flex",
  gap: "6px"
});

export const ReactToastifyErrorWrapper = styled("div")({
  width: "25px",
  height: "25px",
  borderRadius: "50%",
  background: "#a61c03",
  flexShrink: "0",
  display:"flex",
  justifyContent:"center",
  alignItems: "center"
});

export const ReactToastifySuccessWrapper = styled("div")({
  width: "25px",
  height: "25px",
  borderRadius: "50%",
  background: "#03a634",
  flexShrink: "0",
  display:"flex", 
  justifyContent:"center", 
  alignItems: "center"
});

export const ReactToastifyMessage = styled("div")({
  fontSize: "14px",
  fontWeight: "600"
});

export const ReactToastifyDesc = styled("div")({
  fontSize: "12px",
  color: "rgba(17, 25, 42, 0.69)",
  lineHeight: "1.2",
});

export const ReactToastifyAction = styled("a")({
  marginTop: "4px",
  fontSize: "12px",
  color: "rgb(17, 25, 42)",
  padding: "2px 8px",
  border: "1px solid rgb(17, 25, 42)",
  borderRadius: "4px",
  textDecoration: "none",
  display: "inline-block",
});

export const FieldsWrapper = styled(Box)({
  width: "100%",
  mt: 2,
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
})

export const TabWrappers = styled(Box)({
  display: "flex",
  gap: "3",
  mt: "4",
  maxWidth: "100%",
  width: "100%",
  flexWrap: "wrap",
  justifyContent: "center",
})

export const FormWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4",
})

export const FieldsBox = styled(Box)({
  width: "100%",
  justifyContent: "center",
  mt: "2",
})

export const ButtonWrapper = styled('div')({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "14px",
  gap: "12px",
})

export const ButtonsLeftWrapper = styled('div')({
  display: "flex",
  justifyContent: "flex-start",
  marginTop: "14px",
  gap: "12px",
})

export const FeatureDetails = styled('div')({
  marginTop: "12px",
  fontWeight: "700",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#000000"
})

export const FeatureDetailsTitle = styled('h2')({
  fontSize: "18px",
  fontWeight: "bold"
})

export const FeatureDetailsList = styled('ol')({
  display: "flex",
  flexDirection: "column",
  gap: "9px",
  marginTop: "12px",
  paddingInlineStart: "25px"
})

export const FeatureDetailsListItem = styled('li')({
  color: "#424242",
  margin: 0,
  padding: 0,
  fontWeight: "400"
})

export const CustomLink = styled(Link)({
  textDecoration: "none"
})

export const SearchResultLink = styled(Link)({
  textDecoration: "none",
  color: "black",
  marginLeft: "10px",
  "& span": {
    background: "yellow"
  }
})

export const FooterWrapper = styled('div')({
  padding: "22px 27px",
  minHeight: "57px",
  background: "linear-gradient(108.75deg, #1B253C 0.96%, #11192A 111.67%)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "auto"
})

export const FooterLeft = styled('div')({
  fontWeight: "600",
  color: "#D1000E",
  fontSize: "12px"
})

export const FooterRight = styled('div')({
  fontWeight: "600",
  color: "#ffffff",
  fontSize: "10px"
})

export const LoaderContainer = styled('div')({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    minHeight: "200px",
    gap: "16px",
    width: "100%",
    textAlign: "center"
});

export const LoaderText = styled('span')({
    fontSize: "14px",
    color: "#666",
    fontWeight: "400",
    marginTop: "8px"
});